import React from "react";
import { Chip, ChipProps } from "@newsela/angelou";
import { aiChipRootCss } from "./AIChip.style";

type AIChipProps = Omit<ChipProps, "ref"> & {
  variant?: "filter" | "input";
  active?: boolean;
};

const AIChip: React.FC<AIChipProps> = ({
  variant = "filter",
  active,
  __cssFor,
  ...rest
}) => (
  <Chip
    {...rest}
    active={active}
    __cssFor={{
      root: aiChipRootCss(variant, active),
      ...(__cssFor || {}),
    }}
  />
);

export default AIChip;
